import { useRef } from 'react';
import styles from './PoderUploadBox.module.css';

const MAX_DOC_SIZE = 10 * 1024 * 1024;

// Recuadro para subir la carta de poder firmada (nube + "Clic para subir el
// documento"). Lo usan RepresentativeModal (persona externa) y
// RepresentaAModal (un recuadro por propietario representado).
export default function PoderUploadBox({ id, ownerName, file, onFile, onError }) {
  const ref = useRef();

  const handle = (e) => {
    const f = e.target.files[0];
    if (!f) return;
    if (f.size > MAX_DOC_SIZE) {
      onError?.(`El poder de ${ownerName} supera el máximo permitido de 10 MB.`);
      e.target.value = '';
      return;
    }
    onError?.('');
    onFile(f);
  };

  return (
    <div className={`form-group ${styles.caja}`}>
      <label className="form-label" htmlFor={id}>
        Poder firmado por {ownerName} *{' '}
        <span className={styles.leyenda}>(PDF o imagen, máx. 10 MB)</span>
      </label>
      <div role="button" tabIndex={0}
        onClick={() => ref.current?.click()}
        onKeyDown={e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); ref.current?.click(); } }}
        className={file ? `${styles.zona} ${styles.zonaConArchivo}` : `${styles.zona} ${styles.zonaVacia}`}>
        <i className={`fas ${file ? 'fa-file-circle-check' : 'fa-cloud-upload-alt'} ${file ? `${styles.icono} ${styles.iconoConArchivo}` : styles.icono}`} />
        <div className={file ? `${styles.nombre} ${styles.nombreConArchivo}` : styles.nombre}>
          {file ? file.name : 'Clic para subir el documento'}
        </div>
        {file && <div className={styles.cambiar}>Clic para cambiarlo</div>}
      </div>
      <input id={id} ref={ref} type="file" accept=".jpg,.jpeg,.png,.pdf" onChange={handle} className={styles.oculto} />
    </div>
  );
}
